import md5 from 'js-md5'

export function hash (val) {
  return md5(val.toString())
}
